import { request } from './core'
import { buildQueryString } from '../../utils/apiQueryBuilder'

export interface RLEnvironment {
  id: string
  name: string
  github_url: string
  description: string | null
  domain: string | null
  created_at: number
  updated_at: number
  created_by: string | null
  updated_by: string | null
  creator_name: string | null
}

export interface RLEnvironmentCreatePayload {
  name: string
  github_url: string
  description?: string | null
  domain?: string | null
}

export const rlEnvironmentsApi = {
  domains: (params?: { signal?: AbortSignal }) =>
    request<string[]>('/rl-environments/domains', { signal: params?.signal }),

  list: (params?: {
    search?: string
    domain?: string
    page?: number
    page_size?: number
    signal?: AbortSignal
  }) => {
    const { signal, ...queryParams } = params || {}
    const query = buildQueryString(queryParams)
    return request<{ items: RLEnvironment[]; total: number }>(`/rl-environments${query}`, { signal })
  },

  create: (data: RLEnvironmentCreatePayload) =>
    request<RLEnvironment>('/rl-environments', {
      method: 'POST',
      body: JSON.stringify(data),
    }),

  update: (id: string, data: RLEnvironmentCreatePayload) =>
    request<RLEnvironment>(`/rl-environments/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),

  delete: (id: string) =>
    request<void>(`/rl-environments/${id}`, {
      method: 'DELETE',
    }),
}
